// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index.js'

import locale from 'element-ui/lib/locale/lang/en'

import router from './router'

import './assets/css/reset.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI,{
  locale:locale
});


import api from './common/js/api.js'
import api2 from './common/js/api2.js'
import global_variable from './common/js/global_variable.js'
import axios from 'axios'

import Share from 'vue-social-share'
Vue.use(Share)

// push重复路由报错
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
// ----




axios.defaults.baseURL = "https://api.skatescustom.com/index";


import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(store);


import moment from "moment"

Vue.prototype.moment = moment;

Vue.prototype.$api = api;
Vue.prototype.$api2 = api2;
Vue.prototype.global_variable = global_variable;



import vuescroll from 'vuescroll';

Vue.use(vuescroll);

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js